/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-02-23 09:29:47
 * @LastEditors: snzo.chen
 * @LastEditTime: 2021-10-12 16:04:55
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((mod) => mod.HomeModule),
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./pages/news/news.module').then((mod) => mod.NewsModule),
  },
  {
    path: 'score',
    loadChildren: () =>
      import('./pages/score/score.module').then((mod) => mod.ScoreModule),
  },
  {
    path: 'apply',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/apply/apply.module').then((mod) => mod.ApplyModule),
  },
  {
    path: 'tickets',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/tickets/tickets.module').then((mod) => mod.TicketsModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((mod) => mod.LoginModule),
  },
  {
    path: 'online',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/online/online.module').then((mod) => mod.OnlineModule),
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
